import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Tabs,
    Tab,
    Box,
    Paper,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Link,
    Checkbox,
} from "@mui/material";

import WhatsNewTable from "./IndexWhatsNew";

const WhatsNewPopup = ({ open, onClose }) => {
    const [activeTab, setActiveTab] = useState(0);

    const tabLabels = [
        "Whats New",
    ];


    const handleTabChange = (event, newValue) => setActiveTab(newValue);

    const TabPanel = ({ children, value, index }) => (
        <Box
            role="tabpanel"
            hidden={value !== index}
            sx={{
                p: 3,
                backgroundColor: "#fff",
                borderRadius: 1,
                boxShadow: 1,
                minHeight: 240,
            }}
        >
            {value === index && children}
        </Box>
    );

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            sx={{
                "& .MuiDialog-paper": {
                    borderRadius: 2,
                    backgroundColor: "#ebf3fa",
                    width: "90%", // custom width if you want more control
            maxWidth: "1200px", // optional: limit maximum width
                },
            }}
        >
            <DialogTitle
                sx={{
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: "1.3rem",
                    background: "linear-gradient(to right, #0c5a88, #1976d2)",
                    color: "#fff",
                    padding: "8px 20px",
                    lineHeight: 1.0,
                }}
            >
                What's New
            </DialogTitle>

            <DialogContent sx={{ p: 3 }}>
                {/* Tabs Header */}
                <Paper
                    elevation={0}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        backgroundColor: "transparent",
                        mb: 2,
                        mt: 2,
                    }}
                >
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        TabIndicatorProps={{ style: { backgroundColor: "#0c5a88" } }}
                        sx={{
                            "& .MuiTab-root": {
                                textTransform: "none",
                                fontWeight: 600,
                                borderRadius: 1,
                                mx: 0.5,
                                backgroundColor: "#c5e3f6",
                                color: "#0c3d64",
                                minWidth: 140,
                                "&.Mui-selected": {
                                    backgroundColor: "#0c5a88",
                                    color: "#fff",
                                },
                            },
                        }}
                    >
                        {tabLabels.map((label, index) => (
                            <Tab key={index} label={label} />
                        ))}
                    </Tabs>
                </Paper>

                {/* Tab 0: User Manual */}
                <TabPanel value={activeTab} index={0}>
                    <WhatsNewTable
                        tenantId="hp"
                        formType="Whats New"
                    />
                </TabPanel>
            </DialogContent>
        </Dialog>
    );
};

export default WhatsNewPopup;